<template>
	<section class="detail-section"  :style="{backgroundImage:'url(' + bgImg + ')'}">
		<div class="overlay"></div>
		<div class="profile-cover-content">
			<div class="container">
				<h2>{{ title }}</h2>
				<h3 v-if="desc">{{ desc }}</h3>
			</div>
		</div>
	</section>
</template>
<script>
export default {
  name: 'PicBanner',
  props: ['title', 'desc', 'bgImg']
}
</script>